import userTransformer from "@mixins/user-transformer";
import EventBus from "@packages/event-bus";
import Vue from "vue";
import base from "./baseAuth";

export default Object.assign(
    {
        apiUrl: "/account/establishment",

        async create(data) {
            EventBus.$emit("SHOW_SPINNER");

            const parsedUser = userTransformer.parseUser(data);

            const response = await Vue.http
                .post(this.url("/"), {
                    ...parsedUser,
                    isCompany: parsedUser.cpfCnpj.length !== 11
                })
                .catch(error => {
                    EventBus.$emit("CANCEL_SPINNER");
                    throw error;
                });
            EventBus.$emit("CANCEL_SPINNER");
            EventBus.$emit("LOAD_DATA","")
            return response;
        },

        async find(id) {
            const estableshimentFindRes = await Vue.http.get(this.url(`/${id}`));

            return userTransformer.formatUser(estableshimentFindRes);
        },

        async update(data) {
            const url = this.url(`/${data.id}`);
            EventBus.$emit("SHOW_SPINNER");

            const parsedUser = userTransformer.parseUser(data);

            const response = await Vue.http
                .put(url, {
                    ...parsedUser,
                    isCompany: parsedUser.cpfCnpj.length !== 11
                })
                .catch(error => {
                    EventBus.$emit("CANCEL_SPINNER");
                    throw error;
                });
            EventBus.$emit("CANCEL_SPINNER");
            return response;
        },

        async list({page,size,filter,order,desc}) {
            const url = this.url("/"
            );
            const retorno =  await Vue.http.get(url, {
                params: {
                    page,
                    size,
                    filter,
                    order,
                    desc
                }
            });
            return retorno
        },
        async listPartners() {
            const url = this.url("/getlistPartners"
            );
            const retorno =  await Vue.http.get(url, {
                
            });
            return retorno
        },        
    
        async toggleStatus(id) {
            const url = this.url(`/${id}/status`);

            return Vue.http.put(url);
        },

        // async getAdvertisers({ filter }) {
        //     const url = this.userUrl({
        //         path: `/filter/anunciante?filtro=${filter || ""}`
        //     });

        //     return Vue.http.get(url);
        // },

        async clearAccess({ establishmentId, email }) {
            const url = this.url(`/${establishmentId}/acesso/clear`);
            return await Vue.http.post(url, { email });
        },

        // async editPermissions({ establishmentId, value }) {
        //     const url = this.url(`/${establishmentId}`);
        //     EventBus.$emit("SHOW_SPINNER");
        //     const response = await Vue.http
        //         .patch(
        //             url,
        //             userTransformer.parseEstablishmentPermissions(value)
        //         )
        //         .catch(() => {
        //             EventBus.$emit("CANCEL_SPINNER");
        //         });
        //     EventBus.$emit("CANCEL_SPINNER");
        //     return response;
        // },


        async linkPartner({ partnerId, establishmentId }) {
            const url = this.url(`/${establishmentId}/partner/${partnerId}`);
            
            const response = await Vue.http
                .put(url)
                .catch(error => {
                    throw error;
                });
                
            return response;
        },
        
        async removePartner({ establishmentId }) {
            const url = this.url(`/${establishmentId}/partner`);
            
            const response = await Vue.http
                .delete(url)
                .catch(error => {
                    throw error;
                });
                
            return response;
        },

          async togglePermission({ establishmentId, permissionKey  }) {
            const url = this.url(`/${establishmentId}/permission`);

            return Vue.http.patch(url, permissionKey, {
                headers: { "Content-Type": "text/plain" }
            });
        }

        
    },
    base
);
